import { useCreateSelector } from '@insights-gaming/redux-utils';
import { Skeleton } from '@material-ui/lab';
import { NotificationFragment_MemberNotification } from 'apollo/fragments/types/NotificationFragment';
import { makeGetTeamById } from 'features/dashboard/team/dashboard-team-selector';
import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { ID } from 'types/pigeon';

interface MemberNotificationMessageProps {
  notifications: NotificationFragment_MemberNotification[];
}

function MemberNotificationMessage({
  notifications,
}: MemberNotificationMessageProps) {
  const [firstNotfication] = notifications;
  const { actor, team: { id: teamId } } = firstNotfication;
  const team = useCreateSelector(makeGetTeamById, teamId);

  const numberOfExtraActors = useMemo(() => {
    const userIds = new Set<ID>();
    for (const n of notifications) {
      if (n.actor) {
        userIds.add(n.actor.id);
      }
    }
    return userIds.size - 1;
  }, [notifications]);

  if (!team) {
    return <Skeleton variant='text' />;
  }

  const member = actor?.alias || 'somebody';

  return numberOfExtraActors > 0 ? (
    <Trans
    ns='notification'
    i18nKey='notifications.membersnotification'
    values={{ member, numberOfExtraActors, team: team.name }}
    >
      <strong>{member} and {numberOfExtraActors} others</strong> joined <strong>{team.name}</strong>
    </Trans>
  ) : (
    <Trans
    ns='notification'
    i18nKey='notifications.membernotification'
    values={{ member, team: team.name }}
    >
      <strong>{member}</strong> joined <strong>{team.name}</strong>
    </Trans>
  );
}

export default React.memo(MemberNotificationMessage);
